import {type ReactNode, type Ref} from "react";
import {Group} from "@mantine/core";
import {DestructiveButton, PrimaryButton, SecondaryButton} from "./ModalButton";
import classes from "./modalStyles.module.css";

type ButtonConfig = {
    label: ReactNode;
    onClick?: () => void;
    loading?: boolean;
    disabled?: boolean;
    title?: string;
};

export type PrimaryConfig = ButtonConfig & {
    variant?: "primary" | "destructive";
};

export type SecondaryConfig = ButtonConfig & {
    buttonRef?: Ref<HTMLButtonElement>;
};

type ChecklistModalActionsProps = {
    primary?: PrimaryConfig;
    secondary?: SecondaryConfig;
};

export const ChecklistModalActions = ({
    primary,
    secondary,
}: ChecklistModalActionsProps) => {
    const PrimaryComponent =
        primary?.variant === "destructive" ? DestructiveButton : PrimaryButton;

    return (
        <Group justify="space-between" className={classes.modalFooter}>
            {secondary ? (
                <SecondaryButton
                    ref={secondary.buttonRef}
                    onClick={secondary.onClick}
                    disabled={secondary.disabled}
                    title={secondary.title}
                >
                    {secondary.label}
                </SecondaryButton>
            ) : (
                <span />
            )}
            {primary ? (
                <PrimaryComponent
                    onClick={primary.onClick}
                    loading={primary.loading}
                    disabled={primary.disabled}
                    title={primary.title}
                >
                    {primary.label}
                </PrimaryComponent>
            ) : (
                <span />
            )}
        </Group>
    );
};
